function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/* eslint-disable react/prop-types */
import React from 'react';
import LinkedApplicationsListModal from "./LinkedApplicationsListModal";
import { useLazyLoad } from '@applyboard/ab-common';
import useApiObjectList from "../../../../hooks/useApiObjectList";
import { getMultipleApplicationsAction } from "../../../../api/jsonapi";
var Enhancer = function Enhancer(props) {
  var requirementID = props.requirementID;
  var _useLazyLoad = useLazyLoad(getMultipleApplicationsAction, function (perform) {
      return perform({
        'filter[requirement_id]': requirementID,
        include: 'program,program.school'
      });
    }),
    _useLazyLoad2 = _slicedToArray(_useLazyLoad, 2),
    applicationListResponse = _useLazyLoad2[0],
    request = _useLazyLoad2[1];
  var applicationIds = applicationListResponse ? applicationListResponse.map(function (_ref) {
    var id = _ref.id;
    return parseInt(id, 10);
  }) : [];
  var allApplications = useApiObjectList('applications', function (applicationListResponse) {
    return applicationListResponse.filter(function (_ref2) {
      var id = _ref2.id;
      return applicationIds.indexOf(parseInt(id, 10)) >= 0;
    });
  });
  var applicationSchoolAndPrograms = allApplications.map(function (app) {
    return {
      applicationID: app.id,
      schoolName: app.program.school.name,
      programName: app.program.name
    };
  });
  return /*#__PURE__*/React.createElement(LinkedApplicationsListModal, _extends({}, props, {
    applicationSchoolAndPrograms: applicationSchoolAndPrograms,
    request: request
  }));
};
export default Enhancer;